export const pathHelper = (pathname: string) => {
    const ignore_layout = ['/reset-password'];
    if(ignore_layout.includes(pathname)) {
        return true;
    } else {
        return false;
    }
};